import { PureComponent } from "react";
import { withGenericConfig } from "contexts/generic-config-context";
import classnames from "classnames";
import { TITLE_TYPE } from "components/core/short-footer/short-footer-service";
import PictureComponent from "components/core/picture/picture-component";
import { StyledShortFooterLink } from "./short-footer-link.scss";

const LINK_TYPE_TO_CLASS_NAME = {
  [TITLE_TYPE.MAIN]: "main-title",
  [TITLE_TYPE.MAIN_CLICKABLE]: "main-title clickable",
  [TITLE_TYPE.SECONDARY]: "secondary-title",
  [TITLE_TYPE.LINK]: "link"
};

class ShortFooterLink extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, url, translate, type, icon } = this.props;

    return (
      <StyledShortFooterLink className={classnames("short-footer-link-component", LINK_TYPE_TO_CLASS_NAME[type])} href={url}>
        {icon && <PictureComponent className="link-icon" src={icon} alt={translate(title)} />}
        {translate(title)}
      </StyledShortFooterLink>
    );
  }
}

export default withGenericConfig(ShortFooterLink);
